import { version } from '../../package.json'

const production = false
const mode = 'ACTV'
const context = 'actv'
const csnDisplay = 'hex_card'

const apiEndpoint = 'http://127.0.0.1:20080'

const lang = 'en'
const geo = 'gb'
const locale = `${lang}-${geo}`
const tz = 'Europe/Rome'
const timezone = tz

const LOCAL_YMD_FORMAT = 'L'
const LOCAL_HM_FORMAT = 'LT'
const LOCAL_HMS_FORMAT = 'LTS'
const LOCAL_YMDHM_FORMAT = 'L LT'
const LOCAL_YMDHMZ_FORMAT = 'L LT z'
const LOCAL_YMDHMS_FORMAT = 'L LTS'
const LOCAL_YMDHMSZ_FORMAT = 'L LTS z'

export const environment = {
  appVersion: version,
  production,
  mode,
  context,
  csnDisplay,

  apiEndpoint,

  locale,
  lang,
  geo,
  tz,
  timezone,

  LOCAL_YMD_FORMAT,
  LOCAL_HM_FORMAT,
  LOCAL_HMS_FORMAT,
  LOCAL_YMDHM_FORMAT,
  LOCAL_YMDHMZ_FORMAT,
  LOCAL_YMDHMS_FORMAT,
  LOCAL_YMDHMSZ_FORMAT,
}
